import { colors, fontSizes } from '@/theme'
import { Close, Search } from '@mui/icons-material'
import { IconButton, InputAdornment, Box, TextField, Typography } from '@mui/material'

interface SearchSectionProps {
  searchQuery: string
  onSearchChange: (value: string) => void
  isOverLimit?: boolean
  helperText?: string
  helperVariant?: 'info' | 'error'
}

export default function SearchSection({
  searchQuery,
  onSearchChange,
  isOverLimit = false,
  helperText,
  helperVariant = 'info'
}: SearchSectionProps) {
  return (
    <Box>
      <TextField
        value={searchQuery}
        onChange={e => onSearchChange(e.target.value)}
        placeholder='Search by order number, email, name, shipping postcode, or shipping mobile'
        variant='outlined'
        fullWidth
        autoComplete='off'
        error={isOverLimit}
        sx={{
          '& .MuiOutlinedInput-root': {
            bgcolor: colors.background.paper,
            fontSize: fontSizes.lg,
            py: 0.5
          }
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <Search sx={{ color: colors.text.muted, fontSize: '24px' }} />
            </InputAdornment>
          ),
          endAdornment: searchQuery ? (
            <InputAdornment position='end'>
              <IconButton size='small' onClick={() => onSearchChange('')} edge='end'>
                <Close sx={{ fontSize: '20px' }} />
              </IconButton>
            </InputAdornment>
          ) : null
        }}
      />
      {isOverLimit && (
        <Typography variant='caption' color='error' sx={{ px: 1.5, mt: 0.5, display: 'block' }}>
          Search query must be 50 characters or fewer
        </Typography>
      )}
      {!isOverLimit && helperText && (
        <Typography
          variant='caption'
          color={helperVariant === 'error' ? 'error' : 'text.secondary'}
          sx={{ px: 1.5, mt: 0.5, display: 'block' }}
        >
          {helperText}
        </Typography>
      )}
    </Box>
  )
}
